import { eventHasRun } from '../../utils/eventTracker';
import widgetIsPresent from '../../utils/widgetIsPresent';
import getLinkText from '../../utils/getLinkText';
import findVehicleByProperty from '../../utils/findVehicleByProperty';

export const DDC_LINK_GENERIC = 'ddc.link.generic';

function clicked(win, { currentTarget: element, timeStamp, originalEvent }) {
	const {
		DDC: {
			dataLayer: {
				page: {
					pageInfo: { pageWidgets }
				},
				vehicles
			}
		}
	} = win;
	let eventObject;
	if (
		!eventHasRun(DDC_LINK_GENERIC, {
			timeStamp
		}) &&
		element instanceof Element &&
		element?.getAttribute?.('ui-tabs-initial-load') !== 'true' &&
		// US784493 - Next line added so we do not track internal event viewer
		!originalEvent?.path?.some?.((el) =>
			el?.classList?.contains?.('hide-from-ws-tracking')
		) &&
		[undefined, null].includes(
			originalEvent?.target?.closest?.('.hide-from-ws-tracking')
		)
	) {
		if (
			element?.classList?.contains?.('dialog') &&
			!$(element).parents('.ui-dialog').length &&
			element.dataset.title
		) {
			localStorage?.setItem(
				'ddc_data_layer-initiatingClickText',
				$(element).text().trim()
			);
		}

		let department;

		if (element.href?.startsWith('tel:')) {
			const dataClickToCall = element?.closest('[data-click-to-call]')
				?.dataset?.clickToCall;
			const dataPhoneRef =
				element?.closest('[data-phone-ref]')?.dataset?.phoneRef;
			department =
				dataClickToCall || (dataPhoneRef !== 'null' && dataPhoneRef);
		}

		const eventData = {
			text: getLinkText(element, win),
			url: element?.getAttribute?.('href') || '',
			pageName: win.DDC.dataLayer.page.pageInfo.pageName,
			element,
			isSRP: widgetIsPresent(/ws-inv-listing/, pageWidgets),
			...(department && { department })
		};

		if (
			$(element).closest('.page-header').length > 0 ||
			$(element).closest('.ddc-mobile-fragment-nav').length > 0
		) {
			eventData.location = 'mainNav';
		} else if ($(element).closest('.ddc-footer').length > 0) {
			eventData.location = 'footer';
		} else {
			eventData.location = 'content';
		}
		if (eventData.isSRP) {
			const uuid =
				$(element).closest('[data-uuid]').attr('data-uuid') || '';
			const vehicle = uuid
				? findVehicleByProperty('uuid', uuid, vehicles)
				: {};
			eventData.vehicle = vehicle;
		} else if (win.DDC.dataLayer.page.pageInfo.isVdp) {
			[eventData.vehicle] = vehicles;
		}
		eventObject = {
			eventType: DDC_LINK_GENERIC,
			eventData
		};
	}

	if (element instanceof Element) {
		element?.setAttribute?.('ui-tabs-initial-load', false);
	}

	return eventObject;
}

export default clicked;
